import { render, staticRenderFns } from "./filterBlock.vue?vue&type=template&id=5c366dc0"
import script from "./filterBlock.vue?vue&type=script&lang=js"
export * from "./filterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports